/**
 * Which part of a day a booking covers on one of its days: 'full', 'morning' or 'afternoon'.
 * ONE rule for both year planners (Rob 4B, 04/11/2026 — BUGS.md: a person's year planner drew a
 * half day as a whole day, because only My leave worked this out). Moved word for word from
 * MyLeavePage.js; the two planners' month code is to be merged later (decision 13, ROADMAP.md).
 *
 *   start_type: 'morning' | 'afternoon'   end_type: 'lunchtime' | 'end_of_day'
 */
export function dayPortion(req, isFirstDay, isLastDay) {
  const isSingleDay = req.start_date === req.end_date;
  if (isSingleDay) {
    if (req.start_type === 'morning' && req.end_type === 'lunchtime') return 'morning';
    if (req.start_type === 'afternoon' && req.end_type === 'end_of_day') return 'afternoon';
    return 'full';
  }
  if (isFirstDay && req.start_type === 'afternoon') return 'afternoon';
  if (isLastDay && req.end_type === 'lunchtime') return 'morning';
  return 'full';
}
